// extracted by mini-css-extract-plugin
module.exports = {"sliderBlock":"AnimatedSlider_sliderBlock__2WQti","element":"AnimatedSlider_element__3sE_e","sliderBlockHidden":"AnimatedSlider_sliderBlockHidden__34scm"};